import { render, staticRenderFns } from "./EditBIAcces.vue?vue&type=template&id=5bf11944&"
import script from "./EditBIAcces.vue?vue&type=script&lang=ts&"
export * from "./EditBIAcces.vue?vue&type=script&lang=ts&"
import style0 from "./EditBIAcces.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports